import React from "react";
import { Star, Zap, Building } from "lucide-react";
import { cn } from "@/lib/utils";

const icons = { Star, Zap, Building };

const PlanHeader = ({
  plan,
  frontendProps,
  isMember,
  userPlan,
  trialEligible,
}) => {
  const PlanIcon = icons[frontendProps.iconName] || Star;
  const showPrice = true || plan.id === "free" || isMember;
  const showTrialBadge = trialEligible && plan.id !== "free";

  return (
    <div className="flex flex-col items-center p-4">
      <PlanIcon className={cn("h-10 w-10 mb-3", frontendProps.color)} />
      <h3 className="text-2xl font-semibold">{plan.name}</h3>

      {showTrialBadge && (
        <div
          className="mt-2 mb-2 px-4 py-1 bg-gradient-to-r from-primary to-accent
                  text-primary-foreground font-semibold text-sm rounded-full shadow-md
                  transform transition-transform hover:scale-105"
        >
          🎁 30-Day Free Trial
        </div>
      )}

      {showPrice && (
        <div className="text-3xl font-bold mt-1 min-h-[40px] flex items-center justify-center gap-2">
          {plan.price === "Free" || plan.price === 0 ? (
            <span>Free</span>
          ) : (
            <>
              <span>${plan.price}</span>
              {plan.frequency && (
                <span className="text-sm font-normal text-muted-foreground ml-1">
                  /{plan.frequency}
                </span>
              )}
            </>
          )}
        </div>
      )}

      {showTrialBadge && isMember && (
        <p className="text-xs text-muted-foreground mt-1">
          then ${plan.price}/{plan.frequency} after trial
        </p>
      )}
    </div>
  );
};

export default PlanHeader;
